import { useEffect } from "react"
import { NextRouter } from "next/router"

// NOTE: onPopState must be wrapped in useCallback() otherwise it does not work
export const useBrowserNavigation = (router: NextRouter, onPopState: (e: PopStateEvent) => void) => {
    useEffect(() => {
        router.beforePopState((state) => {
            state.options.scroll = false
            return true
        })

        window.addEventListener("popstate", onPopState)

        return () => {
            window.removeEventListener("popstate", onPopState)
        }
    }, [onPopState, router])
}
